import {
    ROOT,
    SU_GET_ALL,
    SU_GET_STATUS,
    SU_GET_IFRAME,
    SU_OTA_GET_DETAIL,
    SU_OTA_UPDATE_DETAIL,
    SU_GET_WIDGET_TOKEN,
    STAAH_MAX_GET_ALL,
    STAAH_MAX_GET_STATUS,
    STAAH_MAX_GET_IFRAME,
    STAAH_MAX_OTA_GET_DETAIL,
    STAAH_MAX_OTA_UPDATE_DETAIL,
    STAAH_MAX_GET_WIDGET_TOKEN,
    STAAH_MAX_SYNC_DATA,
    STAAH_MAX_UPDATE_EXTRA
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

function getAllSuOTA(data) {
    return fetch(ROOT + SU_GET_ALL, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getStatusSuOTA(data) {
    return fetch(ROOT + SU_GET_STATUS, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getIframe(data) {
    return fetch(ROOT + SU_GET_IFRAME, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function detailSyncOTA(id) {
    return fetch(ROOT + SU_OTA_GET_DETAIL + `/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function updateDetailSuOTA(data, id) {
    return fetch(ROOT + SU_OTA_UPDATE_DETAIL + `/${id}`, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function getWidgetToken(id) {
    return fetch(ROOT + SU_GET_WIDGET_TOKEN + `/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function getAllStaahMaxOTA(data) {
    return fetch(ROOT + STAAH_MAX_GET_ALL, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getStatusStaahMaxOTA(data) {
    return fetch(ROOT + STAAH_MAX_GET_STATUS, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getStaahMaxIframe(data) {
    return fetch(ROOT + STAAH_MAX_GET_IFRAME, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function detailStaahMaxSyncOTA(id) {
    return fetch(ROOT + STAAH_MAX_OTA_GET_DETAIL + `/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function updateDetailStaahMaxOTA(data, id) {
    return fetch(ROOT + STAAH_MAX_OTA_UPDATE_DETAIL + `/${id}`, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function getStaahMaxWidgetToken(id) {
    return fetch(ROOT + STAAH_MAX_GET_WIDGET_TOKEN + `/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function updateExtraStaahMax(data) {
  return fetch(ROOT + STAAH_MAX_UPDATE_EXTRA, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function staahMaxSyncData(id) {
  return fetch(ROOT + STAAH_MAX_SYNC_DATA+ `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

//#endregion
export const suOta = {
    getAllSuOTA,
    getStatusSuOTA,
    getIframe,
    detailSyncOTA,
    updateDetailSuOTA,
    getWidgetToken
}

export const staahMaxOta = {
    getAllStaahMaxOTA,
    getStatusStaahMaxOTA,
    getStaahMaxIframe,
    detailStaahMaxSyncOTA,
    updateDetailStaahMaxOTA,
    getStaahMaxWidgetToken,
    updateExtraStaahMax,
    staahMaxSyncData
}